<script>
	import ModalsRenderer from '$lib/components/modals/renderer/ModalsRenderer.svelte';
	import Header from '$lib/components/layout/Header.svelte';
	import Footer from '$lib/components/layout/Footer.svelte';
	import TrackingHandler from '$lib/components/tracking/TrackingHandler.svelte';
	import { animRoutChange, animInit } from '$lib/util/animations';
	import { onNavigate } from '$app/navigation';
	import * as TrackingStore from '$lib/stores/trackingStore';

	import '$lib/assets/styles/library/setup/setup.scss';
	import '$lib/assets/styles/main.scss';
	import '$lib/assets/styles/animations.scss';
	import '$lib/assets/styles/account.scss';
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { PUBLIC_DIRECTUS_BACKEND } from '$env/static/public';
	import CanonicalLinks from '$lib/components/util/CanonicalLinks.svelte';
	import api from '$lib/api/ecom/shopify';
	import Cart from '$lib/components/ecom/Cart.svelte';
	import CartNotification from '$lib/components/ecom/CartNotification.svelte';
	import Toaster from '$lib/components/layout/Toaster.svelte';
	import { init as shopInit } from '$lib/stores/shopStore';

	import { pageList } from '$lib/stores/navStore';

	onMount(async () => {
		animInit();
		shopInit();
		initNavStore();
	});

	onNavigate((navigation) => {
		if (!document.startViewTransition) {
			setTimeout(() => {
				animRoutChange();
			}, 100);
			setTimeout(() => {
				animRoutChange();
			}, 1000);
			setTimeout(() => {
				animRoutChange();
			}, 8000);
			return;
		}

		return new Promise((resolve) => {
			document.startViewTransition(async () => {
				resolve();
				await navigation.complete;
				animRoutChange();
			});
		});
	});

	function initNavStore() {
		pageList.set($page.data.pageList);
	}

	$: {
		if (typeof document !== 'undefined')
			document.documentElement.setAttribute('lang', $page.params.lang);
	}
</script>

<svelte:head>
	{#if $page.data.pageConfig?.plausible_data_domain}
		<script
			defer
			data-domain={$page.data.pageConfig?.plausible_data_domain}
			src="https://analytics.ff.works/js/script.js"
		></script>
	{/if}
	<CanonicalLinks />
</svelte:head>

<TrackingHandler
	keys={{
		googleAnalyticsId: $page.data?.pageConfig?.google_analytics_id,
		googleTagmanagerId: $page.data?.pageConfig?.google_tagmanager_id,
		facebookPixelId: $page.data?.pageConfig?.facebook_pixel_id
	}}
/>

<div dir={$page.data.langDirection} style="--dir: {$page.data.langDirection === 'rtl' ? -1 : 1}">
	<Header />
	<div class="page">
		<slot />
	</div>
	<Footer />

	<Cart />

	<!-- <CartNotification /> -->
	<!-- <Toaster message={'long_text'} /> -->
	<ModalsRenderer />
</div>

<style lang="scss">
	.page {
		padding-top: v(header__height);
		background-color: color(light-grey);

		:global(section:first-child) {
			margin-top: 0 !important;
		}

		&.rtl {
		}
	}
</style>
